const STORAGE_KEY = "hub_exclusive_notifications";

// Generate a session ID that changes on each browser session
const getSessionId = () => {
  if (typeof window === "undefined") return "";

  let sessionId = sessionStorage.getItem("hub_session_id");
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("hub_session_id", sessionId);
  }
  return sessionId;
};

export { STORAGE_KEY, getSessionId };
